
import React from "react";

const NeighborhoodFilter = ({ listingFilter, updateFilter }) => {

    return (
      <div className="rangeSelections row">
        <div className="col-3 text-right">Neighborhood</div>
        <select
          name="MLSAreas"
          className="select custom-select range-select col-4"
          value={listingFilter.MLSAreas || ''}
          onChange={(event) => updateFilter({ MLSAreas: event.target.value })}
        >
          <option value="">Any</option>
          <option value="94,95,96">Arlington</option>
          <option value="94">Arlington Reserve</option>
          <option value="97,98,99,100,101,102">
            Bartlett
        </option>
          <option value="102,99,97">Bartlett Reserve</option>
          <option value="74,75,76,77,78,79,80,81,82">
            Cordova
        </option>
          <option value="107,108,109,110,111,112">Collierville</option>
          <option value="107,72,24">
            Collierville Reserve
        </option>
          <option value="36,40,42">Downtown</option>
          <option value="47,48,49,50,51,52,44,45,46,65,66,67">
            East Memphis
        </option>
          <option value="24,25,26,27,28,29,30">
            Frayser
        </option>
          <option value="103,104,105,106,71,67,65">
            Germantown
        </option>
          <option value="91,92,93">Lakeland</option>
          <option value="92">Lakeland Reserve</option>
          <option value="37,38,39,41,43">Midtown</option>
          <option value="83,84,85,86,87,88,89,90">Millington</option>
          <option value="31,32,33,34,35">Raleigh</option>
          <option value="113,8,9,10,11,12,13,14,15,5,1,2,3,4,6,7,16,17,18,19,20,21,22,23">Rural</option>
          <option value="72,68,69,70,71,73,61,62,63,64">Southwind</option>
          <option value="53,54,55,56,57,58,59,60">Whitehaven</option>
        </select>
      </div>
    );
}
export default NeighborhoodFilter;






